export const getHotelItineraryUrl = (
  itemAddress: string | undefined,
  hotelAddress: string | undefined
): string => {
  if (!itemAddress || !hotelAddress) return '';
  const origin = encodeURIComponent(hotelAddress);
  const destination = encodeURIComponent(itemAddress);
  return `https://www.google.com/maps/dir/${origin}/${destination}`;
};

export const getDirectionsUrl = (address: string): string => {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
};
